// Highcharts spreads the bars over a fixed height, which makes them too thin to read the
// values they hold once a field has many options. The height is computed from the number
// of bars instead, so they keep the same thickness whatever the number of options.
const BAR_HEIGHT = 30;
const CHART_BASE_HEIGHT = 150;

export const barChartHeight = barCount => barCount * BAR_HEIGHT + CHART_BASE_HEIGHT;
